import { createRouter, createWebHistory } from 'vue-router';

import UserAuth from './pages/auth/UserAuth.vue';
import NotFound from './pages/NotFound.vue';
import DeliveriesnewForm from './pages/deliveries/DeliveriesInsert.vue';
import Usuarios from './pages/usuarios/UsuariosList.vue';
import UsuariosInsert from './pages/usuarios/UsuariosInsert.vue';
import UsuariosUpdate from './pages/usuarios/UsuariosUpdate.vue';
import BitacorasList from './pages/bitacoras/BitacorasList.vue';
import TiposViajeList from './pages/tiposviaje/TiposViajeList.vue';
import TiposViajeInsert from './pages/tiposviaje/TiposViajeInsert.vue';
import RepostajesList from './pages/repostajes/RepostajesList.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/auth' },
    { path: '/auth', component: UserAuth },
    { path: '/:catchAll(.*)', redirect: '/notfound' },
    { path: '/notfound', component: NotFound },
    { path: '/newDeliveries', component: DeliveriesnewForm },
    { path: '/usuarios', component: Usuarios },
    { path: '/insert/usuarios', component: UsuariosInsert },
    { path: '/usuarios/:usuario', component: UsuariosUpdate },
    { path: '/bitacora', component: BitacorasList },
    { path: '/tiposviaje', component: TiposViajeList },
    { path: '/insert/tiposviaje', component: TiposViajeInsert },
    { path: '/fuleosdecombustible', component: RepostajesList },
  ],
});

export default router;
